import {
  Component,
  OnInit,
  Inject,
  PLATFORM_ID,
  Renderer2,
} from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { AccountService } from '@services/user-transversal/account.service';
import { ServicesJelpitService } from '@services/services-jelpit/services-jelpit.service';
import { Router } from '@angular/router';
import { ShoppingCartService } from '@services/shopping-cart/shopping-cart.service';
import { Meta } from '@angular/platform-browser';
import { CryptoJSAesEncrypt } from '@cryptoJs/encrypt.service';
import { CryptoJSAesDecrypt } from '@cryptoJs/decrypt.service';
import { SeoService } from '@services/seo/seo.service';
import { NewOrderParamsInterface } from '@interfaces/new-order-params/newOrderParams.interface';
import { ConfirmationCartNewComponent } from '@components/confirmation-cart-new/confirmation-cart-new.component';
import { MatDialog } from '@angular/material/dialog';
import { LoginTransversalService } from '@services/login-transversal/login-transversal.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '@environment/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  setInterval: any;

  constructor(
    @Inject(DOCUMENT) private document,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _accountService: AccountService,
    private renderer: Renderer2,
    private router: Router,
    private metaTagService: Meta,
    private shoppingcartService: ShoppingCartService,
    private loginTransversalService: LoginTransversalService,
    private servicesJelpitService: ServicesJelpitService,
    private encrypt: CryptoJSAesEncrypt,
    private decrypt: CryptoJSAesDecrypt,
    private seoService: SeoService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private cookieService: CookieService,
    private accountService: AccountService
  ) { }

  ngOnInit(): void {
    this.seoService.createCanonicalUrl();
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('name');
      localStorage.removeItem('token-node');
    }
    this.loadJSGoogleMaps();
    this.metaTagService.updateTag({
      name: 'robots',
      content: 'noindex, nofollow',
    });
  }

  ngAfterViewInit(): void {
    this.loadLogin();
  }

  loadJSGoogleMaps(): void {
    if (isPlatformBrowser(this.platformId)) {
      let script = this.renderer.createElement('script');
      script.setAttribute('async', 'async');
      script.src =
        `https://maps.googleapis.com/maps/api/js?key=${environment.googleKey}&libraries=places`;
      this.renderer.appendChild(this.document.body, script);
    }
  }

  loadLogin() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        let loginSystem = window['loginSystem'];
        if (loginSystem !== undefined) {
          loginSystem.loadLogin();
          document.getElementById('login-box').className = 'show_element';
          this.setInterval = setInterval(() => {
            if (localStorage.getItem('token-node') !== null) {
              if (localStorage.getItem('name') !== null) {
                this.loginSocialNetwork();
              } else {
                this.loginUser();
              }
              clearInterval(this.setInterval);
            }
            if (localStorage.getItem('recover-mail') !== null) {
              this.forgotPassword(localStorage.getItem('recover-mail'));
              clearInterval(this.setInterval);
            }
          }, 1000);
        } else {
          this.loadLogin();
        }
      }, 1000);
    }
  }

  forgotPassword(mail: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('recover-mail');
    }
    this._accountService
      .sendMailResetPassword(mail)
      .subscribe((response) => {});
  }

  loginUser(): void {
    this._accountService.loginSession().subscribe((responserLogin: any) => {
      let dataUser = JSON.parse(
        this.decrypt.cryptoJSAesDecrypt(responserLogin.result.user)
      );
      if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem('dataUser', btoa(JSON.stringify(dataUser)));
        localStorage.setItem('token-session', responserLogin.result.token);
        localStorage.setItem('firstLogin', 'true');
        if (dataUser.last_address !== null) {
          const data = {
            ...dataUser.last_address,
            confirm_my_location: true,
            is_address_has_additional_data: dataUser.last_address.complement_address === null ? true : false,
            address_components: {},
            formatted_address: ''
          }
          localStorage.setItem('dataTempAddress', JSON.stringify(data));
          localStorage.setItem('directionTemp', JSON.stringify(data));
        }
      }

      this._accountService.verifyToken().subscribe((response: any) => {
        if (isPlatformBrowser(this.platformId)) {
          localStorage.setItem('uid', response.uid);
        }
      });

      if (
        !dataUser.phone ||
        !dataUser.document_type ||
        !dataUser.document_number
      ) {
        this.router.navigateByUrl('/register/datos-adicionales');
        return;
      }
      if (isPlatformBrowser(this.platformId)) {
        if (localStorage.getItem('userIDNoLogin')) {
          const changeUserProducts = {
            old_external_user_id: localStorage.getItem('userIDNoLogin'),
            external_user_id: dataUser.id,
          };

          this.shoppingcartService
            .setChangeProductCart(changeUserProducts)
            .subscribe(
              (response: any) => {
                this.logicChangeProductCart();
              },
              (error: any) => {
                this.logicChangeProductCart();
              }
            );
        } else {
          const clientId =  {
            ga:this.cookieService.get('_ga'),
            gid:this.cookieService.get('_gid')
          }
          this.accountService.sendClientId({ value: this.encrypt.CryptoJSAesEncrypt(JSON.stringify(clientId)) }).subscribe(response =>{})
          window.location.href = "/";
        }
      }
    });
  }

  logicChangeProductCart(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('dataTempFormNoLogin');
      localStorage.removeItem('userIDNoLogin');

      if (localStorage.getItem('dataTempForm')) {
        let dataFormDynamic = JSON.parse(
          atob(localStorage.getItem('dataTempForm'))
        );
        localStorage.removeItem('dataTempForm');
        if (localStorage.getItem('dataTempUserForm')) {
          localStorage.removeItem('dataTempUserForm');
        }
        let dataRecurrentPayment = {};
        if (localStorage.getItem('dataRecurrentPay')) {
          dataRecurrentPayment = JSON.parse(
            atob(localStorage.getItem('dataRecurrentPay'))
          );
        }
        this.createNewOrderDetail(
          dataFormDynamic,
          dataRecurrentPayment
        );
        return;
      }
      let query = localStorage.getItem('QueryParams');
      if (query) {
        window.location.href = '/carrito-de-compras?' + query;
      } else {
        window.location.href = '/carrito-de-compras';
      }
    }
  }

  loginSocialNetwork() {
    if (isPlatformBrowser(this.platformId)) {
      let registerData = localStorage.getItem('name').toString().split(' ');

      let user: any = {};

      switch (registerData.length) {
        case 2:
          user.first_name = registerData[0].replace('%20', ' ');
          user.middle_name = '';
          user.last_name = registerData[1].replace('%20', ' ');
          user.second_last_name = '';
          break;
        case 3:
          user.first_name = registerData[0].replace('%20', ' ');
          user.middle_name = '';
          user.last_name = registerData[1].replace('%20', ' ');
          user.second_last_name = registerData[2].replace('%20', ' ');
          break;
        default:
          user.first_name = registerData[0].replace('%20', ' ');
          user.middle_name = registerData[1].replace('%20', ' ');
          user.last_name = registerData[2].replace('%20', ' ');
          user.second_last_name = registerData[3].replace('%20', ' ');
          break;
      }

      user.email = localStorage.getItem('email').toString().replace('%40', '@');
      user.commercial_information = '1';
      localStorage.setItem('UserRegister', JSON.stringify(user));
      this._accountService
        .registerUser(
          { value: this.encrypt.CryptoJSAesEncrypt(JSON.stringify(user)) },
          localStorage.getItem('token-node'),
          localStorage.getItem('uid')
        )
        .subscribe(
          (response: any) => {
            localStorage.setItem(
              'dataUser',
              btoa(
                JSON.parse(
                  this.decrypt.cryptoJSAesDecrypt(response.result.user)
                )
              )
            );
            localStorage.setItem('token-session', response.result.token);
            localStorage.removeItem('userIDNoLogin');
            this.router.navigate(['/register/datos-adicionales']);
          },
          (error: any) => {
            if (error.status === 422) {
              this.loginUser();
            }
          }
        );
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      clearInterval(this.setInterval);
      if (localStorage.getItem('recover-mail')) {
        localStorage.removeItem('recover-mail');
      }
    }
  }

  createNewOrderDetail(dataFormDynamic: any, dataRecurrentPayment: any) {
    const orderParams: NewOrderParamsInterface =
      this.servicesJelpitService.getNewOrderParams(dataFormDynamic);
    const cryptoListOrdes: any = this.servicesJelpitService.encryptData(
      orderParams.listOrders
    );
    const {
      urlReturn,
      anotherData,
      nameService,
      category,
      description,
      products,
      dataUserPayment,
    } = orderParams;
    this.servicesJelpitService
      .setDataCreateOrderNewDetail({ value: cryptoListOrdes })
      .subscribe(
        (data: any) => {
          const dataAtob: any = this.servicesJelpitService.decryptData(
            data.result.value
          );
          if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem('audience_token');
          }
          if (Object.entries(dataRecurrentPayment).length !== 0) {
            this.servicesJelpitService.processOrderByRecurrentPayment(
              dataUserPayment,
              dataAtob,
              anotherData,
              urlReturn
            );
          } else {
            const data: any = {
              nameService: nameService,
              total: dataAtob[0]?.total,
              category: category,
              description: description,
              products: products,
            };
            this.servicesJelpitService.processOrderByNotRecurrentPayment(
              data,
              ConfirmationCartNewComponent,
              this.dialog
            );
          }
        },
        (error) => {
          this._snackBar.open(
            error?.error.messages[Object.keys(error?.error.messages)[0]],
            'Aceptar',
            {
              duration: 4000,
            }
          );
        }
      );
  }
}
